/* eslint-disable no-unused-vars */
import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sizes } from 'src/styles/Media.styled';
import ItemsListRPContainerDesktop from './ReportPaymentItemListDesktop';
import ItemsListRPContainerMobile from './ReportPaymentItemListMobile';
import {
    getModifiedItemTableData,
    getNewItemObj,
    productIssueErrMsg,
    invalidProductMsg,
    invalidUnidRodItemQtyMsg,
    lotNumberReqdMsg,
    serialNumberReqdMsg,
    getUniqueKey,
    getRPValidateItemsArr,
    getProductsArrFromReportPaymentFlow,
    modifyDraftProductsResponse,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import {
    storeItemTableData,
    setAllAccountOwned,
    validateProductDetails,
    storeUsageDataPresist,
    setReportPaymentFlag,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import { ReportUsageContext } from 'src/pages/reportUsage';
import WarningModal from 'src/pages/reportUsage/common/warningModal';
import { SET_ITEMS_DURING_PRICING } from 'src/pages/reportUsage/redux/action/types';
import { generate_UUID, isIpad } from 'src/utils/util';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import { useTranslation } from 'react-i18next';
import { resetBarcodeDetails } from 'src/common/barCodeScannerRedux/actions/actionCreators';
import { displayCheckbox } from 'src/pages/reportUsage/utils/eventHandlerUtil';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const ItemsListContext = React.createContext({});

const ItemListRPView = ({ ...props }) => {
    const winWidth = window.innerWidth;
    const dispatch = useDispatch();

    const {
        filteredProduct,
        setFilteredProduct,
        selectedProduct,
        addedProduct,
        resetSelectedOrAddedItem,
        setShowHidePricesBtn,
        setToggleHidePricesBtn,
        isFromReportScreen,
        checkboxReportPaymentClickHandler,
        reportPaymentGridData,
        setReportPaymentGridData,
        selectedCheckBox,
        checkBoxSelectedIndex,
        checkNewAddedProduct,
        deletePO,
        deleteItem,
        onImagePreview,
        showBundlefromTableList,
        addedChildProduct,
        selectedChildProduct,
        setAddedChildProduct,
        setSelectedChildProduct,
        setAddedProduct,
    } = props;
    const { usageDetails, reportUsageFormObj, setReportUsageFormObj } =
        useContext(ReportUsageContext);
    const { t } = useTranslation();
    const bundleHeadersArr =
        usageDetails?.bundleHeaders && usageDetails?.bundleHeaders.split(',');
    const { products } = useSelector((state) => ({
        products: state.productsSearchReducer.products,
    }));
    const pricedItems = useSelector(
        (state) => state.reportUsageRootReducer.pricedItems
    );
    const itemsToBePriced = useSelector(
        (state) => state.reportUsageRootReducer.itemsToBePriced
    );
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const reportPaymentFlag = useSelector(
        (state) => state.reportUsageRootReducer.reportPaymentFlag
    );
    const [selectedChildEditItem, setSelectedChildEditItem] = useState(false);
    const [selectedChildIndex, setSelectedChildIndex] = useState();
    const [selectedChildItem, setSelectedChildItem] = useState();
    const [allAccountSelectedModal, setAllAccountSelectedModal] =
        useState(false);
    const [isBundleExpanded, setIsBundleExpanded] = useState(true);
    const myCaseResourceType = useSelector(
        (state) => state.reportUsageRootReducer.myCaseResourceType
    );
    const [loaderOnOrientationChange, setLoaderOnOrientationChange] =
        useState(false);

    const myCaseRefId = useSelector(
        (state) => state.reportUsageRootReducer.myCaseRefId
    );

    window.onorientationchange = () => {
        if (isIpad()) {
            setLoaderOnOrientationChange(true);
            setTimeout(() => setLoaderOnOrientationChange(false), 1000);
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            pricedItems &&
            pricedItems.length > 0 &&
            reportPaymentGridData.length > 0
        ) {
            let modifiedData = getModifiedItemTableData(
                reportPaymentGridData,
                pricedItems,
                bundleHeadersArr,
                isFromReportScreen,
                usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
                myCaseResourceType
            );
            if (myCaseResourceType === 'reportPayment') {
                modifiedData = modifiedData.map((item) => {
                    if (!item.payment && item.isAdditionalCartEntry) {
                        return {
                            ...item,
                            poImageErrorMsg: t(
                                'productValidationMessages.poInfoRequired'
                            ),
                            isPoImageError: true,
                        };
                    } else {
                        return item;
                    }
                });
            }
            setReportPaymentGridData(modifiedData);
            setShowHidePricesBtn(true);
            setToggleHidePricesBtn('hideBtn');
            // setRpInitialLoad(true);
        }
    }, [pricedItems]);

    // Create Object for Added Item
    // const [lotFromScanner, setLotFromScanner] = useState(null);

    useEffectWithErrorLogging(() => {
        var newProduct = [...reportPaymentGridData];
        let newObject = {};
        if (addedProduct?.value && Object.keys(addedProduct).length > 0) {
            const existingItem = newProduct.find((item) => {
                return (
                    item.cfn == addedProduct.value &&
                    item?.lotSerialNumber ==
                        addedProduct?.barcodeData?.batchOrSerialNumber
                );
            });
            const existingItemIndex = newProduct.findIndex(
                (item) =>
                    item.cfn == addedProduct.value &&
                    item?.lotSerialNumber ==
                        addedProduct?.barcodeData?.batchOrSerialNumber
            );
            if (
                existingItem &&
                existingItemIndex !== -1 &&
                !addedChildProduct?.isFromBundleItemScanner &&
                !addedProduct?.isFromAddItem
            ) {
                newProduct[existingItemIndex].usedQuantity =
                    (parseInt(newProduct[existingItemIndex].usedQuantity) ||
                        0) + 1;
                setFilteredProduct(newProduct);
                setReportPaymentGridData(newProduct);
            } else {
                const newlyAddedItem = getNewItemObj(
                    addedProduct,
                    {},
                    true,
                    bundleHeadersArr,
                    false,
                    myCaseResourceType
                );
                if (addedProduct.isBundle) {
                    newlyAddedItem.isBundleFromAddItem = true;
                    newlyAddedItem.bundleItem = [];
                    newlyAddedItem.isBundleItem = addedProduct.isBundle;
                    newlyAddedItem.bundleHeaderPosition =
                        newProduct.filter((data) =>
                            bundleHeadersArr?.includes(
                                data.cfn?.toUpperCase()
                            )
                        ).length;
                }
                newlyAddedItem.unqId = `${getUniqueKey()} ${
                    addedProduct.value
                }`;
                newlyAddedItem.productCFN = addedProduct.value;
                newProduct.push(newlyAddedItem);
                // setLotFromScanner(newlyAddedItem?.lotSerial[0]?.Serial);
                setFilteredProduct(newProduct);
                for (let item of newProduct) {
                    newObject = {
                        ...newObject,

                        basePrice: item.basePrice,
                        id: generate_UUID(),
                        unqId: generate_UUID(),
                        description: item.description,
                        extPrice: item.extPrice,
                        isAccountOwned: item.accountOwned,
                        isAdditionalCartEntry: item.isAdditionalCartEntry,
                        isReplenish: item.isReplenish,
                        productCFN: item.cfn,
                        cfn: item.cfn,
                        salesOrg: item.salesOrg,
                        uom: item.uom,
                        unitPrice: item.unitPrice,
                        usedQuantity: item?.bundleItem
                            ? item.usedQuantity
                                ? item.usedQuantity
                                : 1
                            : item.usedQuantity,
                        lotSerialNumber: item?.lotSerial
                            ? item?.lotSerial[0]?.Serial
                            : item.lotSerialNumber,
                        //  usedQtyExtPrice: item.usedQtyExtPrice,
                        usedQtyExtPrice: item.usedQtyExtPrice,
                        isBundleFromAddItem: item?.isBundleFromAddItem,
                        bundleItem: item?.bundleItem,
                        isBundleItem: item?.isBundleItem,
                        bundleHeaderPosition: item?.bundleHeaderPosition,
                        isPriced: false,
                        scannedGTIN: item?.scannedGTIN ? item?.scannedGTIN : '',
                        // otherQtyExtPrice: item.otherQtyExtPrice,
                    };
                }

                const chekgriddata = [
                    ...reportPaymentGridData,
                    {
                        ...newObject,
                        isAdditionalCartEntry: true,
                    },
                ];
                setReportPaymentGridData(chekgriddata);
            }
            dispatch(setAllAccountOwned(false));
            resetSelectedOrAddedItem();
            setAddedProduct({});
        }
    }, [addedProduct]);

    useEffectWithErrorLogging(() => {
        var newProduct = [...reportPaymentGridData];
        let newObject = {};
        if (selectedProduct?.value && Object.keys(selectedProduct).length > 0) {
            const filteredList = products.filter(
                (item) =>
                    item.cfn === selectedProduct.value &&
                    item.salesOrg === selectedProduct.salesOrg
            );
            if (filteredList?.length > 0) {
                filteredList[0].unqId = `${getUniqueKey()} ${
                    selectedProduct.value
                }`;
                if (selectedProduct.isBundle) {
                    filteredList[0].isBundleFromAddItem = true;
                    filteredList[0].bundleItem = [];
                    filteredList[0].isBundleItem = selectedProduct.isBundle;
                    filteredList[0].bundleHeaderPosition =
                        newProduct.filter((data) =>
                            bundleHeadersArr?.includes(
                                data.cfn?.toUpperCase()
                            )
                        ).length;
                }
                newProduct.push(filteredList[0]);
                setReportPaymentGridData(newProduct);
                for (let item of newProduct) {
                    newObject = {
                        ...newObject,
                        basePrice: item.basePrice,
                        description: item.description,
                        extPrice: item.extPrice,
                        isAccountOwned: item.accountOwned,
                        id: generate_UUID(),
                        unqId: generate_UUID(),
                        isAdditionalCartEntry: item.isAdditionalCartEntry,
                        isReplenish: item.isReplenish,
                        productCFN: item.cfn,
                        cfn: item.cfn,
                        salesOrg: item.salesOrg,
                        uom: item.uom,
                        unitPrice: item.unitPrice,
                        usedQuantity: item?.bundleItem
                            ? item.usedQuantity
                                ? item.usedQuantity
                                : 1
                            : item.usedQuantity,
                        lotSerialNumber: item.lotSerialNumber,
                        //  usedQtyExtPrice: item.usedQtyExtPrice,
                        usedQtyExtPrice: item.usedQtyExtPrice,
                        isBundleFromAddItem: item?.isBundleFromAddItem,
                        bundleItem: item?.bundleItem,
                        isBundleItem: item?.isBundleItem,
                        bundleHeaderPosition: item?.bundleHeaderPosition,
                        isPriced: false,
                        // otherQtyExtPrice: item.otherQtyExtPrice,
                    };
                }

                const chekgriddata = [
                    ...reportPaymentGridData,
                    {
                        ...newObject,
                        isAdditionalCartEntry: true,
                    },
                ];
                // const chekgriddata = newProduct
                //     .filter((item) => {
                //         return item !== undefined;
                //     })
                //     .map((item) => {
                //         return {
                //             ...item,
                //             basePrice: item.basePrice,
                //             description: item.description,
                //             extPrice: item.extPrice,
                //             isAccountOwned: item.accountOwned,
                //             isAdditionalCartEntry: item.isAdditionalCartEntry,
                //             isReplenish: item.isReplenish,
                //             productCFN: item.cfn,
                //             cfn: item.cfn,
                //             salesOrg: item.salesOrg,
                //             uom: item.uom,
                //             unitPrice: item.unitPrice,
                //             usedQuantity: item.usedQuantity,
                //             lotSerialNumber: item.lotSerialNumber,
                //             //  usedQtyExtPrice: item.usedQtyExtPrice,
                //             usedQtyExtPrice: item.usedQtyExtPrice,
                //             // otherQtyExtPrice: item.otherQtyExtPrice,
                //         };
                //     });

                setReportPaymentGridData(chekgriddata);

                dispatch(setAllAccountOwned(false));
            }
        }
    }, [selectedProduct]);

    useEffectWithErrorLogging(() => {
        if (
            selectedChildProduct?.child &&
            Object.keys(selectedChildProduct).length > 0
        ) {
            var newProduct = filteredProduct;
            let filteredList = [];
            let filteredProductList = [];
            let selectedIndex = selectedChildProduct.parent.index;
            let selectedParentItem = selectedChildProduct.parent.cfn;

            filteredList = newProduct?.filter((item) => {
                return item?.cfn == selectedParentItem
                    ? selectedParentItem
                    : '';
            });

            if (filteredList) {
                if (!newProduct[selectedIndex].children)
                    newProduct[selectedIndex].children = [];
                newProduct[selectedIndex].bundleItem = [];
                newProduct[selectedIndex].isBundleExpanded = true;

                const filteredChildProducts = products.filter(
                    (item) => item?.cfn === selectedChildProduct?.child
                );

                if (selectedChildProduct.isBundle) {
                    filteredChildProducts[0].isBundleFromAddItem = true;
                    filteredChildProducts[0].isBundleItem = true;
                    filteredChildProducts[0].isInvalidItemMsg = t(
                        'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                    );
                } else if (filteredChildProducts[0].isSet) {
                    filteredChildProducts[0].isInvalidItemMsg = t(
                        'equity.common.utils.setsNotAllowed'
                    );
                } else if (filteredChildProducts[0].salesOrg === 'S030') {
                    filteredChildProducts[0].isInvalidItemMsg = t(
                        'equity.common.utils.tissueItems'
                    );
                }
                filteredChildProducts[0].productCFN =
                    filteredChildProducts[0].cfn;
                filteredChildProducts[0].isBundleChild = true;
                filteredChildProducts[0].isAdditionalCartChild = true;
                filteredChildProducts[0].id = generate_UUID();
                filteredChildProducts[0].isPriced = false;
                newProduct[selectedIndex].noItemInBundleErr = null;
                newProduct[selectedIndex].bundleItem.push({
                    ...filteredChildProducts[0],
                    lotSerial: [{ used: false, id: getUniqueKey() }],
                });
                reportPaymentGridData[selectedIndex].noItemInBundleErr = null;
                reportPaymentGridData[selectedIndex].bundleItem.push({
                    ...filteredChildProducts[0],
                });
                setReportPaymentGridData(reportPaymentGridData);
            }

            filteredProductList = newProduct.filter((item) => {
                return item !== undefined;
            });
            const newArray = filteredProductList;
            setFilteredProduct(newArray);
            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            setSelectedChildProduct('');
        }
    }, [selectedChildProduct]);

    useEffectWithErrorLogging(() => {
        myCaseResourceType === 'reportPayment' && dispatch(storeItemTableData(reportPaymentGridData));
        const accountOwnedItems =
            reportUsageFormObj.products?.length > 0
                ? reportUsageFormObj.products

                      .map((item, index) => {
                          if (item.isAccountOwned || item.accountOwned) {
                              return {
                                  ...item,
                                  recordIndex: index,
                              };
                          } else {
                              return item;
                          }
                      })
                      .filter(
                          (filterItem) =>
                              filterItem.isAccountOwned ||
                              filterItem.accountOwned
                      )
                : [];
        let updatedItem = [...reportPaymentGridData];
        accountOwnedItems.map((ownedItem) => {
            let temp = {
                ...ownedItem,
            };
            delete temp.recordIndex;
            updatedItem.splice(ownedItem.recordIndex, 0, temp);
        });
        const productsArr = getProductsArrFromReportPaymentFlow(updatedItem);
        const draftProducts = modifyDraftProductsResponse(
            productsArr,
            usageDetails.bundleHeaders
                ? usageDetails.bundleHeaders.split(',')
                : [],
            usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
            true
        );
        setFilteredProduct(draftProducts);
        dispatch({
            type: 'SET_LOCAL_USAGE_TABLE_DATA',
            payload: draftProducts,
        });
        // dispatch(
        //     storeUsageDataPresist({
        //         name: 'reportPayment',
        //         value: reportPaymentGridData,
        //     })
        // );
        // let updatedItem = reportPaymentGridData;
        // const productsArr = getProductsArrFromReportPaymentFlow(updatedItem);
        // const draftProducts = modifyDraftProductsResponse(
        //     productsArr,
        //     usageDetails.bundleHeaders
        //         ? usageDetails.bundleHeaders.split(',')
        //         : [],
        //     usageDetails.unidSurgeryInfoPage?.deliveredRodItems,
        //     true
        // );
        // setFilteredProduct(draftProducts);
        // dispatch({
        //     type: 'SET_LOCAL_USAGE_TABLE_DATA',
        //     payload: draftProducts,
        // });
    }, [reportPaymentGridData]);

    const onAccountOwnedSeleted = (item, index) => {
        let newAry = [...reportPaymentGridData];
        let isAllSelected = true;
        newAry[index] = { ...item, accountOwned: !item.accountOwned };
        if (newAry.length >= 1) {
            newAry.map((item) => {
                if (!item.accountOwned) {
                    isAllSelected = false;
                }
            });
            setAllAccountSelectedModal(isAllSelected);
            dispatch(setAllAccountOwned(isAllSelected));
        }
        if (!isAllSelected) {
            setFilteredProduct(newAry);
        }
    };
     const onIsSerialUnknown = (item, index, value, bundleIndex) => {
         let newArray =
             bundleIndex != 0
                 ? [...reportPaymentGridData][bundleIndex].bundleItem
                 : [...reportPaymentGridData];
        
         let islotSerialUnknownSelection = value;

         newArray[index] = {
             ...item,
             lotSerialNumber:
                 islotSerialUnknownSelection !== undefined
                     ? null
                     : item?.lotSerialNumber,
             lotSerialUnknown: islotSerialUnknownSelection,
             isInvalidLotSerialMsg:
                 islotSerialUnknownSelection !== undefined
                     ? null
                     : item?.isInvalidLotSerialMsg,
         };
          setReportPaymentGridData(newArray);
     };

    const deleteAll = () => {
        setFilteredProduct([]);
        resetSelectedOrAddedItem();
    };

    const editItem = (item, index, bundleIndex) => {
        const newAry = [...reportPaymentGridData];

        if (bundleIndex != undefined) {
            newAry[bundleIndex].bundleItem[index] = {
                ...item,
                isEditable: true,
            };
        } else {
            newAry[index] = {
                ...item,
                isEditable: true,
            };
        }

        setReportPaymentGridData(newAry);
    };

    const editChildItem = (item, childIndex) => {
        setSelectedChildEditItem(true);
        setSelectedChildItem(item);
        setSelectedChildIndex(childIndex);
    };

    const addSerialNumber = (item, index, bundleIndex) => {
        let newAry = [...filteredProduct];
        if (bundleIndex != undefined) {
            newAry[bundleIndex].children[index].lotSerial.push({});
            setFilteredProduct(newAry);
        } else {
            newAry[index].lotSerial.push({});
            setFilteredProduct(newAry);
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            addedChildProduct?.child &&
            Object.keys(addedChildProduct).length > 0
        ) {
            var newProduct = [...reportPaymentGridData];
            let filteredList = [];
            let filteredProductList = [];
            let selectedParentIndex = addedChildProduct.parent.index;
            let selectedParentItem = addedChildProduct.parent.cfn;

            filteredList = newProduct?.filter(
                (item) => item.cfn === selectedParentItem
            );
            
            if (filteredList) {
                const existingChildItem = filteredList[0]?.children?.find(
                    (child) =>
                        child.cfn === addedChildProduct?.child &&
                        child?.lotSerialNumber ==
                            addedChildProduct?.lotFromScanner
                                ?.batchOrSerialNumber
                );

                const existingChildItemIndex =
                    filteredList[0]?.children?.findIndex(
                        (child) =>
                            child.cfn === addedChildProduct?.child &&
                            child?.lotSerialNumber ==
                                addedChildProduct?.lotFromScanner
                                    ?.batchOrSerialNumber
                    );

                if (existingChildItem && existingChildItemIndex !== -1) {
                    existingChildItem.usedQuantity =
                        (parseInt(existingChildItem.usedQuantity) || 0) + 1;

                    newProduct[selectedParentIndex].isBundleExpanded = true;
                    reportPaymentGridData[
                        selectedParentIndex
                    ].noItemInBundleErr = null;

                    newProduct[selectedParentIndex].noItemInBundleErr = null;
                    newProduct[selectedParentIndex].children[
                        existingChildItemIndex
                    ] = existingChildItem;
                    const reportPaymentChildIndex = reportPaymentGridData[
                        selectedParentIndex
                    ]?.bundleItem?.findIndex(
                        (child) =>
                            child.cfn === addedChildProduct?.child &&
                            child?.lotSerialNumber ==
                                addedChildProduct?.lotFromScanner
                                    ?.batchOrSerialNumber
                    );
                    if (reportPaymentChildIndex !== -1) {
                        reportPaymentGridData[selectedParentIndex].bundleItem[
                            reportPaymentChildIndex
                        ] = existingChildItem;
                    }
                    setReportPaymentGridData(reportPaymentGridData);
                    filteredProductList = newProduct.filter(
                        (item) => item !== undefined
                    );

                    const newArray = filteredProductList.map((item) => {
                        return {
                            ...item,
                            accountOwned: item.accountOwned
                                ? item.accountOwned
                                : false,
                        };
                    });
                    setFilteredProduct(newArray);
                } else {
                    const newlyAddedChildItem = {
                        quantity: addedChildProduct?.lotFromScanner ? '1' : '',
                        productCFN: addedChildProduct?.child,
                        isBundleChild: true,
                        dailyRate: '',
                        description: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.description
                            : '',
                        salesOrg: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.salesOrg
                            : '',
                        uom: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner?.productDetails
                                  ?.uom
                            : '',
                        lotSerialNumber: addedChildProduct?.lotFromScanner
                            ? addedChildProduct?.lotFromScanner
                                  ?.batchOrSerialNumber
                            : '',
                        accountOwned: false,
                        usedQuantity: addedChildProduct?.lotFromScanner
                            ? '1'
                            : '',
                        isBundleFromAddItem: addedChildProduct.isBundle,
                        isSet: addedChildProduct.isSet,
                        isAdditionalCartChild: true,
                        cfn: addedChildProduct?.child,
                        id: generate_UUID(),
                        unqId: generate_UUID(),
                        isPriced: false,
                    };

                    if (addedChildProduct.isBundle) {
                        newlyAddedChildItem.isBundleItem = true;
                        newlyAddedChildItem.isInvalidItemMsg = t(
                            'productValidationMessages.bundleCannotBeAddedAsItemMsg'
                        );
                    }

                    if (!newProduct[selectedParentIndex]?.children)
                        newProduct[selectedParentIndex].children = [];

                    newProduct[selectedParentIndex].isBundleExpanded = true;
                    reportPaymentGridData[
                        selectedParentIndex
                    ].noItemInBundleErr = null;

                    newProduct[selectedParentIndex].noItemInBundleErr = null;
                    newProduct[selectedParentIndex].children.push(
                        newlyAddedChildItem
                    );
                    reportPaymentGridData[selectedParentIndex]?.bundleItem.push(
                        newlyAddedChildItem
                    );
                    setReportPaymentGridData(reportPaymentGridData);
                    filteredProductList = newProduct.filter(
                        (item) => item !== undefined
                    );

                    const newArray = filteredProductList.map((item) => {
                        return {
                            ...item,
                            accountOwned: item.accountOwned
                                ? item.accountOwned
                                : false,
                        };
                    });
                    setFilteredProduct(newArray);
                }
            }

            dispatch({ type: 'SET_ITEMS_PRICING_DONE_FLAG', payload: false });
            setAddedChildProduct('');
            resetSelectedOrAddedItem();
            dispatch(resetBarcodeDetails());
        }
    }, [addedChildProduct]);

    const editedItemList = (e, item, idx, bundleIndex) => {
        const newAry =
            bundleIndex != undefined
                ? [...reportPaymentGridData][bundleIndex].bundleItem
                : [...reportPaymentGridData];

        const newValue = e.target.value.trim();

        if (
            newAry[idx].isInvalidItemMsg === invalidProductMsg() &&
            newAry[idx].cfn.toUpperCase() === newValue.toUpperCase()
        ) {
            return;
        } else {
            if (newAry[idx].cfn.toUpperCase() !== newValue.toUpperCase()) {
                if (
                    itemsToBePriced &&
                    itemsToBePriced.length > 0 &&
                    itemsToBePriced.includes(newAry[idx].cfn)
                ) {
                    let cfnArray = [newAry[idx].cfn];
                    newAry[idx].isBundleItem &&
                        newAry[idx].bundleItem?.map((bundle) =>
                            cfnArray.push(bundle.productCFN)
                        );

                    dispatch({
                        type: SET_ITEMS_DURING_PRICING,
                        payload: itemsToBePriced.filter(
                            (x) => !cfnArray.includes(x)
                        ),
                    });
                }
                newAry[idx] = getNewItemObj(
                    e.target,
                    newAry[idx],
                    false,
                    bundleHeadersArr,
                    bundleIndex >= 0,
                    myCaseResourceType
                );
            } else {
                newAry[idx] = {
                    ...item,
                    isInvalidItemMsg:
                        newAry[idx].isInvalidItemMsg === invalidProductMsg()
                            ? null
                            : newAry[idx].isInvalidItemMsg,
                    cfn: newValue,
                    productCFN: newValue,
                    isEditable: false,
                };
            }
            if (bundleIndex != undefined) {
                let temp = [...reportPaymentGridData];
                temp[bundleIndex].bundleItem = newAry;
                setReportPaymentGridData(temp);
            } else {
                setReportPaymentGridData(newAry);
                dispatch(setReportPaymentFlag(!reportPaymentFlag));
            }
        }
    };

    const editedChildItemList = (e, item, parentIndex) => {
        let newAry = [...filteredProduct];
        if (e.key === 'Enter' || e.keyCode === 13 || e.keyCode === 9) {
            newAry[parentIndex].children[selectedChildIndex] = {
                ...item,
                cfn: e.target.value,
            };
            setFilteredProduct(newAry);
            setSelectedChildEditItem(false);
        }
    };

    const lotSerialQtyInputChangeHandler = (
        e,
        item,
        index,
        i,
        indexes,
        checkedQty,
        bundleIndex
    ) => {

        var newArray =
            bundleIndex != undefined
                ? [...reportPaymentGridData][bundleIndex].bundleItem
                : [...reportPaymentGridData];
        const selectedObj = newArray[index];

        const isUnidBatchPresent = Object.prototype.hasOwnProperty.call(
            e,
            'batches'
        );

        if (
            item.isInvalidUnidItemQuantity &&
            isUnidBatchPresent &&
            selectedObj.lotSerialNumber !== e.batches
        ) {
            newArray[index].isInvalidQtyMsg =
                newArray[index].selectedBatchValue !== e.batches
                    ? null
                    : invalidUnidRodItemQtyMsg;
        }

        if (
            (item.salesOrg !== 'S030' ||
                item.salesOrg === '' ||
                !item.salesOrg) &&
            !displayCheckbox(item)
        ) {
            let values = {
                ...selectedObj,
                isInvalidQtyMsg: selectedObj.isInvalidQtyMsg
                    ? selectedObj.isInvalidQtyMsg
                    : '',
                [isUnidBatchPresent ? 'lotSerialNumber' : e.target.name]:
                    isUnidBatchPresent
                        ? e.batches || ''
                        : e.target.name === 'usedQuantity'
                        ? isNaN(parseInt(e.target.value))
                            ? ''
                            : parseInt(e.target.value)
                        : e.target.value?.trim(),
            };
            if (
                !isUnidBatchPresent &&
                (e.target.name === 'usedQuantity' ||
                    e.target.name.toLowerCase() === 'other')
            ) {
                if (
                    !newArray[index].isInvalidItemMsg &&
                    e.target.value.length > 0 &&
                    (e.target.value === '0' || e.target.value === '00')
                ) {
                    values.isInvalidQtyMsg = t(
                        'productValidationMessages.mustEnterUsedQuantity'
                    );
                } else if (
                    !newArray[index].isInvalidItemMsg &&
                    e.target.value.length > 0 &&
                    +e.target.value > 1 &&
                    item?.cfn?.startsWith('S33')
                ) {
                    values.isInvalidQtyMsg = t(
                        'productValidationMessages.feeQtyCanOnlyOne'
                    );
                } else if (
                    item.isInvalidUnidItemQuantity &&
                    item.batchQtyObjArr?.length > 0
                ) {
                    const batchQtyObj = item.batchQtyObjArr.filter(
                        (b) =>
                            b.batch === values.lotSerialNumber && b.deliveredQty
                    );
                    if (batchQtyObj && batchQtyObj[0]) {
                        const unidDeliveredQty = batchQtyObj[0].deliveredQty;

                        const totalUnidQty =
                            isNaN(values.usedQuantity) || !values.usedQuantity
                                ? 0
                                : parseInt(values.usedQuantity);

                        values.isInvalidQtyMsg =
                            totalUnidQty &&
                            unidDeliveredQty &&
                            totalUnidQty > parseInt(unidDeliveredQty)
                                ? invalidUnidRodItemQtyMsg
                                : null;
                    } else {
                        values.isInvalidQtyMsg = null;
                    }
                } else {
                    values.isInvalidQtyMsg = null;
                }
            }
            newArray[index] = values;
        }

        if (
            !isUnidBatchPresent &&
            (item.salesOrg === 'S030' || displayCheckbox(item))
        ) {
            if (checkedQty === 'usedChecked') {
                newArray[index] = {
                    ...selectedObj,
                    usedQuantity:
                        selectedObj.usedQuantity !== undefined
                            ? !selectedObj.usedQuantity
                            : false,
                    isInvalidQtyMsg:
                        !selectedObj.usedQuantity === true ? null : false,
                };
            } else {
                newArray[index] = {
                    ...selectedObj,
                    usedQuantity:
                        selectedObj.usedQuantity !== undefined
                            ? selectedObj.usedQuantity
                            : false,

                    [e.target.name]: e.target.value?.trim(),
                };
            }
        }

        if (
            !isUnidBatchPresent &&
            e.target.name === 'lotSerialNumber' &&
            (newArray[index].isLotSerialReqd ||
                newArray[index].isSerialRequired) &&
            !newArray[index].isInvalidItemMsg
        ) {
            if (e.target.value?.trim()?.length > 0) {
                const productsExceptFocused = newArray.filter(
                    (obj, i) =>
                        i !== index &&
                        obj.lotSerialNumber === newArray[index].lotSerialNumber
                );
                newArray[index].isInvalidLotSerialMsg =
                    !newArray[index].isLot &&
                    productsExceptFocused
                        .map((y) => y.lotSerialNumber)
                        .includes(e.target.value)
                        ? productIssueErrMsg
                        : false;
                if (
                    productsExceptFocused.every(
                        (z) => z.isInvalidLotSerialMsg === productIssueErrMsg
                    ) &&
                    newArray[index].isInvalidLotSerialMsg === productIssueErrMsg
                ) {
                    newArray[index].isInvalidLotSerialMsg = false;
                }
            } else {
                newArray[index].isInvalidLotSerialMsg =
                    newArray[index].isLot && !newArray[index]?.lotSerialUnknown
                        ? lotNumberReqdMsg()
                        : newArray[index]?.productCFN.startsWith('S33')
                        ? 'VendorCaseId field should not be Empty'
                        : !newArray[index]?.lotSerialUnknown && serialNumberReqdMsg();
                newArray[index].linkedSstref =
                    newArray[index]?.linkedSstref?.length > 0
                        ? newArray[index]?.lotSerialNumber?.length > 0
                            ? newArray[index]?.linkedSstref
                            : ''
                        : '';
            }
        }
        if (bundleIndex != undefined) {
            let temp = [...reportPaymentGridData];
            temp[bundleIndex].bundleItem = newArray;
            temp[bundleIndex].bundleItem[index].quantity =
                temp[bundleIndex].bundleItem[index].usedQuantity;
            setReportPaymentGridData(temp);
        } else {
            setReportPaymentGridData(newArray);
        }
    };

    return (
        <>
            {allAccountSelectedModal ? (
                <>
                    <WarningModal
                        id={'reportUsage-warning-modal-account-owned'}
                        message={t(
                            'reportUsage.record.reportPayment.ItemList.ItemListRPView.msg'
                        )}
                        onClose={() => setAllAccountSelectedModal(false)}
                        title={t('reportUsage.summary.accountOwned')}
                    />
                </>
            ) : null}
            {loaderOnOrientationChange ? (
                <Backdrop
                    showCloseButton={false}
                    showBackdrop={true}
                    isModal
                    loaderBackground
                >
                    <Spinner
                        id="reportUsage-itemListRPView-backdrop-loadingSpinner"
                        animation="border"
                        variant="primary"
                        small
                    ></Spinner>
                </Backdrop>
            ) : (
                <>
                    {winWidth <= sizes.smalDevice ? (
                        <ItemsListRPContainerMobile
                            winWidth={winWidth}
                            filteredProduct={filteredProduct}
                            selectedChildEditItem={selectedChildEditItem}
                            selectedChildItem={selectedChildItem}
                            selectedChildIndex={selectedChildIndex}
                            onAccountOwnedSeleted={onAccountOwnedSeleted}
                            deleteAll={deleteAll}
                            deleteItem={deleteItem}
                            editItem={editItem}
                            editChildItem={editChildItem}
                            addSerialNumber={addSerialNumber}
                            editedItemList={editedItemList}
                            editedChildItemList={editedChildItemList}
                            lotSerialValueEntered={
                                lotSerialQtyInputChangeHandler
                            }
                            isBundleExpanded={isBundleExpanded}
                            setIsBundleExpanded={setIsBundleExpanded}
                            reportUsageFormObj={reportUsageFormObj}
                            setReportUsageFormObj={setReportUsageFormObj}
                            usageDetails={usageDetails}
                            isFromReportScreen={isFromReportScreen}
                            checkNewAddedProduct={checkNewAddedProduct}
                            checkboxReportPaymentClickHandler={
                                checkboxReportPaymentClickHandler
                            }
                            reportPaymentGridData={reportPaymentGridData}
                            setReportPaymentGridData={setReportPaymentGridData}
                            selectedCheckBox={selectedCheckBox}
                            checkBoxSelectedIndex={checkBoxSelectedIndex}
                            deletePO={deletePO}
                            onImagePreview={onImagePreview}
                            myCaseResourceType={myCaseResourceType}
                            onIsSerialUnknown={onIsSerialUnknown}
                            {...props}
                        />
                    ) : (
                        <ItemsListRPContainerDesktop
                            winWidth={winWidth}
                            filteredProduct={filteredProduct}
                            selectedChildEditItem={selectedChildEditItem}
                            selectedChildItem={selectedChildItem}
                            selectedChildIndex={selectedChildIndex}
                            onAccountOwnedSeleted={onAccountOwnedSeleted}
                            deleteAll={deleteAll}
                            deleteItem={deleteItem}
                            editItem={editItem}
                            editChildItem={editChildItem}
                            addSerialNumber={addSerialNumber}
                            editedItemList={editedItemList}
                            editedChildItemList={editedChildItemList}
                            lotSerialValueEntered={
                                lotSerialQtyInputChangeHandler
                            }
                            isBundleExpanded={isBundleExpanded}
                            setIsBundleExpanded={setIsBundleExpanded}
                            reportUsageFormObj={reportUsageFormObj}
                            setReportUsageFormObj={setReportUsageFormObj}
                            usageDetails={usageDetails}
                            isFromReportScreen={isFromReportScreen}
                            checkNewAddedProduct={checkNewAddedProduct}
                            checkboxReportPaymentClickHandler={
                                checkboxReportPaymentClickHandler
                            }
                            reportPaymentGridData={reportPaymentGridData}
                            setReportPaymentGridData={setReportPaymentGridData}
                            selectedCheckBox={selectedCheckBox}
                            checkBoxSelectedIndex={checkBoxSelectedIndex}
                            deletePO={deletePO}
                            onImagePreview={onImagePreview}
                            myCaseResourceType={myCaseResourceType}
                            showBundlefromTableList={showBundlefromTableList}
                            resetSelectedOrAddedItem={resetSelectedOrAddedItem}
                            onIsSerialUnknown={onIsSerialUnknown}
                            {...props}
                        />
                    )}
                </>
            )}
        </>
    );
};

export default ItemListRPView;
